module.exports = __webpack_public_path__ + "img/doc__uz__id_doc.2b1afe70.png";